import DF from '@/lib/define';
// axios を require してインスタンスを生成する
const axiosBase = require('axios');

const axios = axiosBase.create({
  baseURL: `${DF.API_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json',
});

const axios_user = axiosBase.create({
  baseURL: `${DF.USER_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json',
});

function loader (vue) {
  const my = this;
  // ===========================================================================
  // private var
  // ===========================================================================
  // 送信データオブジェクト
  var post_data = null;
  // ===========================================================================
  // public var
  // ===========================================================================
  // コールバック関数
  my._post_cb_f = null;
  // 本通信クラスでのエラー表示時用コールバック
  my._err_cb_func = null;
  // ===========================================================================
  // private function
  // ===========================================================================
  function data_set (obj) {
    // torken情報埋め込み
    obj.token = vue.$store.getters['loginInfo/login_token'];
    obj.lang = vue.$store.getters['loginInfo/lang'];
    // POSTデータ(json)生成
    post_data = JSON.stringify(obj);
  }

  function upload_data_set(obj, file1, file2, module) {
    obj.token = vue.$store.getters['loginInfo/login_token'];
    obj.lang = vue.$store.getters['loginInfo/lang'];
    const res = JSON.stringify(obj);
    const request_data = JSON.stringify({data:res, module: module});
    const form_data = new FormData();
    form_data.append('upload_file1', file1);
    form_data.append('upload_file2', file2);
    form_data.append('data', request_data);
    // POSTデータ(json)生成
    post_data = form_data;
  }

  function post_data_set (data) {
    post_data = data;
  }

  function upload_start () {
    if (!window.navigator.onLine) {
      vue.$alert('alert', vue.$DF.MESSEGE_ERR_NETWORK);
      if (my._err_cb_func !== null) {
        my._err_cb_func();
      }
      return;
    }

    vue.$store.commit('loading/set_loading', true);
    axios.post('', post_data)
      .then((response) => {
        vue.$store.commit('loading/set_loading', false);
        if (response.data.res === vue.$DF.RES_OK) {
          // コールバック実行
          if (my._post_cb_f !== null) {
            my._post_cb_f(response.data);
          }
        } else if (response.data.res === vue.$DF.RES_LOGIN_ERR) {
          // セキュリティエラー
          vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_LOGIN}`);
        } else {
          // その他のエラー
          vue.$alert('alert', `${response.data.data.message}`);
        }
      })
      .catch((error) => {
        vue.$store.commit('loading/set_loading', false);
        vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_COMM}\n\n[${error}]`);
        if (my._err_cb_func !== null) {
          my._err_cb_func();
        }
      });
  }

  function load_start (url) {
    if (!window.navigator.onLine) {
      vue.$alert('alert', vue.$DF.MESSEGE_ERR_NETWORK);
      if (my._err_cb_func !== null) {
        my._err_cb_func();
      }
      return;
    }

    vue.$store.commit('loading/set_loading', true);
    axios.post('', {
      data: post_data,
      module: url,
    })
      .then((response) => {
        vue.$store.commit('loading/set_loading', false);
        if (response.data.res === vue.$DF.RES_OK) {
          // コールバック実行
          if (my._post_cb_f !== null) {
            my._post_cb_f(response.data);
          }
        } else if (response.data.res === vue.$DF.RES_LOGIN_ERR) {
          // セキュリティエラー
          vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_LOGIN}`);
        } else {
          // その他のエラー
          vue.$alert('alert', `${response.data.data.message}`);
        }
      })
      .catch((error) => {
        vue.$store.commit('loading/set_loading', false);
        vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_COMM}\n\n[${error}]`);
        if (my._err_cb_func !== null) {
          my._err_cb_func();
        }
      });
  }

  function data_set_user (obj) {
    // torken情報埋め込み
    obj.token = vue.$store.getters['loginInfo/login_token'];
    obj.lang = vue.$store.getters['loginInfo/lang'];
    // POSTデータ(json)生成
    post_data = obj;
  }

  function load_start_user (url) {
    if (!window.navigator.onLine) {
      vue.$alert('alert', vue.$DF.MESSEGE_ERR_NETWORK);
      if (my._err_cb_func !== null) {
        my._err_cb_func();
      }
      return;
    }

    vue.$store.commit('loading/set_loading', true);
    axios_user.post('', {
      data: post_data,
      module: url,
    })
      .then((response) => {
        vue.$store.commit('loading/set_loading', false);
        if (response.data.res === vue.$DF.RES_OK) {
          // コールバック実行
          if (my._post_cb_f !== null) {
            my._post_cb_f(response.data);
          }
        } else if (response.data.res === vue.$DF.RES_LOGIN_ERR) {
          // セキュリティエラー
          vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_LOGIN}`);
        } else {
          // その他のエラー
          vue.$alert('alert', `${response.data.data.message}`);
        }
      })
      .catch((error) => {
        vue.$store.commit('loading/set_loading', false);
        vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_COMM}\n\n[${error}]`);
        if (my._err_cb_func !== null) {
          my._err_cb_func();
        }
      });
  }

  //==============================================================================================
  //public function
  //==============================================================================================
  this._data_set = data_set;
  this._load_start = load_start;
  this._data_set_user = data_set_user;
  this._load_start_user = load_start_user;
  this._upload_data_set = upload_data_set;
  this._upload_start = upload_start;
  this._post_data_set = post_data_set;
}
export default loader;
